import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// PWA service worker registration — enables app-shell offline reload so
// providers can cold-load Field View with poor cell. The SW itself
// (public/sw.js) caches the SPA shell + static assets; the existing
// offlineStore handles per-job data via localStorage.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .catch((err) => {
        // Failure is non-fatal — the app still works online.
        // eslint-disable-next-line no-console
        console.warn('SW registration failed:', err);
      });
  });
}
